module.exports = __webpack_public_path__ + "img/c1.65c89397.png";